import React from 'react';

// material ui
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from '@material-ui/core';

// styles
import { Theme } from 'assets/types';

export interface ClassroomLinkItemProps {
  key: string;
  url: string;
  imageUrl: string;
  imageAlt: string;
  title: string;
  description: string;
}

export default function ClassroomLinkItem(item: ClassroomLinkItemProps) {
  const classes = useStyles();

  const handleButtonClick = (item: ClassroomLinkItemProps) => {
    window.open(item.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Card className={classes.container}>
      <CardMedia
        className={classes.image}
        image={item.imageUrl}
        title={item.imageAlt}
      />
      <CardContent className={classes.cardContent}>
        <Box>
          <Typography variant='h5' style={{ fontWeight: 800 }}>
            {item.title}
          </Typography>
          <Typography variant='subtitle2'>{item.description}</Typography>
        </Box>
        <Button
          variant='contained'
          className={classes.button}
          fullWidth
          onClick={() => handleButtonClick(item)}
        >
          Start here!
        </Button>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: '20px',
    backgroundColor: theme.palette.grey[100],
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 400,
    boxShadow: '0px 3px 6px rgba(0,0,0,0.1)',
    padding: '20px',
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
  },
  image: {
    width: '100%',
    height: 250,
    objectFit: 'cover',
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));
